import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import { ProductCar } from '../../models/productCar.model';
import { Plan } from '../../models/plan.model';
import { modifyProduct, removeToCar, modifyTokenProduct } from '../../redux/actions/carCheckout.actions';
import { removePlanFromCar } from '../../redux/actions/carPlanCheckout.actions';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { Encrypt } from '../../utils/encrypt/encrypt';
import { UserInformation } from '../../models/userInformation.model';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';
import { DataLayerService } from '../../services/dataLayer/data-layer.service';
import { CcLoginComponent , PasswordRecoverComponent , CcRegisterComponent} from 'cc-components-lib';
import { ProductsService } from 'src/app/services/products/products.service';

@Component({
  selector: 'app-shopping-dialog',
  templateUrl: './shopping-dialog.component.html',
  styleUrls: ['./shopping-dialog.component.scss']
})

export class ShoppingDialogComponent implements OnInit {

  aditionalProducts: ProductCar[] = [];
  planSelected: Plan[] = [];
  summary: number = 0;
  count: number = 0;
  summaryPlan: number = 0;
  countPlan: number = 0;
  havePlan: boolean = false;
  idStatus:number = 0;
  havePlanOnCar: boolean = false;
  userInformation: UserInformation;
  image_url: string = './assets/images/products/shopping/';
  userPrivateZone: boolean = false;
  confirmPlan: boolean = false;
  user_id: string = '';
  clientType:number= 0;
  transactionStatusId: number = null;
  hasActiveProperties: boolean = false;

  constructor(
    private productsService: ProductsService,
    private cookieCiencuadras: CookieCiencuadras,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ShoppingDialogComponent>,
    private router: Router,
    private store: Store<AppState>,
    private dataLayerService: DataLayerService,
    @Inject(DOCUMENT) document: any
  ) {

  }

  async ngOnInit(): Promise<void> {

    if (document.location.pathname === '/productos/zona-de-usuario') {
      this.userPrivateZone = true;
    }


    let cripto = new Encrypt();

    this.user_id = this.cookieCiencuadras.getCookie('user_id') ? this.cookieCiencuadras.getCookie('user_id') : localStorage.getItem('currentUser');


    this.store.select('carPlanCheckout').subscribe(plan => {
      this.countPlan = 0;
      this.count = this.count + this.countPlan;
      plan.forEach(item => {
        this.planSelected.push(item);
        this.countPlan = plan.length;
        this.count = this.count + this.countPlan;
        this.summaryPlan = item.priceDiscount;
        this.summary = this.summary + this.summaryPlan;
      });
    });

    this.store.select('carCheckout').subscribe(product => {
      this.aditionalProducts = product;
      this.summary = 0 + this.summaryPlan;
      this.count = 0 + this.countPlan;
      product.forEach(item => {
        this.summary = this.summary + item.totalPrice;
        this.count = this.count + item.quantity;
      });
    });

    let dataUser = this.cookieCiencuadras.getCookie('userInfo');
    this.userInformation = cripto.decryptData(dataUser);

  

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  removeall() {
    this.dataLayerService.pushTagEventClick({'event':'ga_event','category':'carrito','action':'CCW - vaciar','label':'Vaciar carrito'});
    this.planSelected.forEach(plan => this.store.dispatch(removePlanFromCar({ id: plan.id })));
    this.aditionalProducts.forEach(product => this.store.dispatch(removeToCar({ id: product.id })));
    this.dialogRef.close();
    this.router.navigateByUrl('/');

  }

  public openPaymentForm(): void {
    console.log('Client Type: ', this.clientType );
    switch(this.clientType) {
      case 1:
          this.router.navigateByUrl('/pagos');
        break;
      case 2:
          this.router.navigateByUrl('/pagos');
        break;
      case 3:
          this.router.navigateByUrl('/pagos');
        break;
      case 4:
          this.router.navigateByUrl('/checkout');
        break;
      case 9:
        this.hasActiveProperties && this.router.navigateByUrl('/pagos');
        break;
    }
  }


  async consultingInformation() {

    let cripto = new Encrypt();
    let id: number = parseInt(cripto.decryptDataIV(this.user_id).split('|')[0]);

    try{
      const response =  await this.productsService.activePlans(id).toPromise();
      this.clientType = response.result.usuario.idTypeUser;
      this.hasActiveProperties = !!response.result.usuario.activeProperties && response.result.usuario.activeProperties.length > 0;
      if(response.result.activePlans.length !== 0) this.idStatus = response.result.activePlans[0].idStatus;
    } catch {
      console.log("Ocurrio un error validando el plan del usuario")
    }

    let dataLayerProduct: { name: string; id: number; price: number; category: string; quantity: number; }[] = [];

    if (this.planSelected.length > 0) {
      this.planSelected.forEach(plan => {
        const newPlan = {
          name: plan.name,
          id: plan.id,
          price: plan.priceDiscount,
          category: "Publicacion",
          quantity: 1,
        }
        dataLayerProduct.push(newPlan)
      });
    }


    if (this.aditionalProducts.length > 0) {
      this.aditionalProducts.forEach(product => {
        const newProduct = {
          name: product.name,
          id: product.id,
          price: product.priceDiscount,
          category: "Publicacion",
          quantity: product.quantity,
        }
        dataLayerProduct.push(newProduct)
      });
    }

    this.dataLayerService.onPushDataLayer({
      event: "checkout",
      ecommerce: {
        checkout: {
          actionField: { step: 1, option: "Medio de pago seleccionado" },
          products: dataLayerProduct,
        },
      },
    });

    if (!this.user_id) {
      const customEvent = new CustomEvent('eventFromMfe', {detail: {modal: 1 , typeUser: 'user'}});
      window.dispatchEvent(customEvent);
      return;
    }

    console.log(this.idStatus, "este es el status del usuario")

    if(this.planSelected.length !== 0 || this.idStatus === 1){
      this.openPaymentForm();
    }
    this.dialogRef.close();
  }

  OpenOnboardingModal(Onboarding: any){
    this.dialog.closeAll();
    if(Onboarding.modal == 1){
      this.OpenLoginModal(Onboarding.typeUser);
    } 
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    } 
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    } 
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialog.open(CcLoginComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialog.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });   
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });   
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialog.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

}
